import { ConnectionType } from '@/types'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { getSelectedConnectionType } from '@/lib/api/connection-type'
import { Button } from '@/components/ui/button'
import {
  Credenza,
  CredenzaBody,
  CredenzaClose,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
} from '@/components/ui/credenza'
import {
  DialogClose,
  DialogContent,
  DialogFooter,
} from '@/components/ui/dialog'
import EditConnectionTypesForm from '@/components/forms/edit-connection-types-form'

export const Route = createFileRoute(
  '/_home/meter-connection-settings/connection-type/edit',
)({
  component: EditConnectionTypesPage,
})

export default function EditConnectionTypesPage({
  connectionTypeData,
  setShowEditConnectionTypeModal,
}: {
  connectionTypeData: ConnectionType
  setShowEditConnectionTypeModal: React.Dispatch<React.SetStateAction<boolean>>
}) {
  return (
    <main>
      {/*       <DialogContent className="md:max-w-[850px]">
        <EditConnectionTypesForm />
        <DialogFooter className="flex flex-row justify-end gap-2 md:mr-4">
          <DialogClose>
            <Button variant="outline" type="submit" className="w-28">
              Cancel
            </Button>
          </DialogClose>
          <Button type="submit" className="w-28">
            Save Changes
          </Button>
        </DialogFooter>
      </DialogContent> */}

      <CredenzaContent className="flex w-full max-w-[850px] justify-center">
        <CredenzaBody>
          <EditConnectionTypesForm
            connectionType={connectionTypeData}
            setShowEditConnectionTypeModal={setShowEditConnectionTypeModal}
          />
        </CredenzaBody>
      </CredenzaContent>
    </main>
  )
}
